import { render, staticRenderFns } from "./MessagesHistory.vue?vue&type=template&id=7721e111&scoped=true&"
import script from "./MessagesHistory.vue?vue&type=script&lang=ts&"
export * from "./MessagesHistory.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesHistory.vue?vue&type=style&index=0&id=7721e111&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7721e111",
  null
  
)

export default component.exports